// FAQ-frågor och svar för Trädfällarna Laholm AB.
// Tonen ska vara trygg, kortfattad, praktisk och kundnära.
// Inga absoluta juridiska svar — hänvisa till kommunen vid tillståndsfrågor och offert vid prisfrågor.

export const FAQS = {
  tillstand: {
    question: "Får jag fälla träd på min tomt utan tillstånd?",
    answer:
      "I många fall får du fälla träd på din egen tomt, men det kan finnas undantag. Inom vissa detaljplanerade områden, nära skyddad natur eller om trädet har särskilt skyddsvärde kan regler gälla. Är du osäker hjälper vi gärna till att bedöma situationen och kan hänvisa dig vidare till kommunen vid behov.",
  },
  pris: {
    question: "Vad kostar trädfällning?",
    answer:
      "Priset beror på trädets storlek, placering, risker, åtkomst och om du även vill ha stubbfräsning eller bortforsling. Ett träd som står fritt är oftast enklare än ett träd nära hus, ledningar, vägar eller andra känsliga ytor. Skicka gärna en bild och beskriv platsen, så kan vi göra en första bedömning.",
  },
  saker_nara_hus: {
    question: "Är det säkert att fälla träd nära hus?",
    answer:
      "Ja, med rätt metod och utrustning kan även svåra träd tas ner kontrollerat. Vid trånga lägen kan vi använda sektionsfällning, klättring eller kranbil beroende på vad platsen kräver. Vi gör alltid en bedömning av trädets storlek, lutning och omgivning innan arbetet planeras.",
  },
  rut: {
    question: "Hur fungerar det med RUT-avdrag?",
    answer:
      "För privatpersoner kan vissa trädgårdsarbeten omfattas av RUT-avdrag. Vi hjälper gärna till att tydliggöra vad som gäller för arbetet i offerten och hanterar avdraget på ett smidigt sätt när förutsättningarna är uppfyllda.",
  },
  varfor_frasa: {
    question: "Varför ska man fräsa stubben istället för att gräva upp den?",
    answer:
      "Stubbfräsning är ofta ett smidigare och mer skonsamt sätt att ta bort en stubbe. I stället för att gräva upp hela rotsystemet fräser man ner stubben på plats, vilket lämnar mindre påverkan på marken och gör ytan enklare att använda igen.",
  },
  fras_djup: {
    question: "Hur djupt går ni ner med stubbfräsen?",
    answer:
      "Djupet beror på platsen, stubben och vad ytan ska användas till efteråt. Ofta räcker det att fräsa ner stubben en bit under marknivå för att kunna lägga jord, gräs eller annan yta ovanpå. Vid offert kan vi bedöma vilket djup som passar bäst för ditt behov.",
  },
  beskarning_tid: {
    question: "När är bästa tiden att beskära träd?",
    answer:
      "Det beror på trädslag och syfte med beskärningen. Vissa träd beskärs bäst under vinter/vår medan andra lämpar sig bättre under sensommar eller den så kallade JAS-perioden. Vi hjälper gärna till att bedöma rätt tidpunkt utifrån trädet och vad du vill uppnå.",
  },
  forsakring: {
    question: "Hur fungerar försäkring om något skulle hända?",
    answer:
      "Trädfällning ska alltid utföras med rätt metod, riskbedömning och utrustning. Om du anlitar ett professionellt företag är det viktigt att arbetet utförs tryggt och ansvarsfullt. Har du frågor kring försäkring för ett specifikt uppdrag går vi gärna igenom förutsättningarna innan arbetet startar.",
  },
  kontrollera_trad: {
    question: "Hur vet jag om ett träd behöver kontrolleras?",
    answer:
      "Tecken som kan vara bra att reagera på är röta, svamp vid stammen eller rötterna, sprickor, rörelse i rotpartiet, gles krona, döda grenar, saknade löv eller att trädet börjat luta mer än tidigare. Om du känner dig osäker är det klokt att låta någon titta på trädet innan det blir en risk.",
  },
  helhetslosning: {
    question:
      "Kan ni hjälpa till med både trädfällning, stubbfräsning och bortforsling?",
    answer:
      "Ja, vi kan hjälpa till med hela kedjan. Det går att boka enbart trädfällning, men många väljer även stubbfräsning och bortforsling så att tomten lämnas ren och lätt att använda efteråt.",
  },
};

// Subset per sida — bara frågor som verkligen visas på respektive sida
// hamnar i FAQPage-schemat.
export const HOME_FAQS = [
  FAQS.tillstand,
  FAQS.pris,
  FAQS.saker_nara_hus,
  FAQS.rut,
  FAQS.kontrollera_trad,
  FAQS.helhetslosning,
  FAQS.forsakring,
];

export const TRADFALLNING_FAQS = [
  FAQS.tillstand,
  FAQS.pris,
  FAQS.saker_nara_hus,
  FAQS.kontrollera_trad,
  FAQS.forsakring,
  FAQS.helhetslosning,
];

export const STUBBFRASNING_FAQS = [
  FAQS.varfor_frasa,
  FAQS.fras_djup,
  FAQS.helhetslosning,
];

export const BESKARNING_FAQS = [
  FAQS.beskarning_tid,
  FAQS.kontrollera_trad,
  FAQS.rut,
];

export const KONTAKT_FAQS = [
  FAQS.pris,
  FAQS.rut,
  FAQS.saker_nara_hus,
  FAQS.tillstand,
];
